import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Modal,
  TableData,
  Input,
  SecondaryButton,
} from "extranet-component-library";
import alert from "../assets/img/ALERTA_CTM.svg";
import alert_alt from "../assets/img/ALERTA_CTM_alt.svg";
import { useStores } from "../hooks/useStores";
import AllLines from "../components/AllLines";
import ConfirmModal from '../components/ConfirmModal';
import { showSnackbar } from '../utils/parsers';

interface FavProps {
  favLines: Array<any>;
  allLines: Array<any>;
  loading: boolean;
}

const FavLines = ({ ...props }: FavProps) => {
  const { t } = useTranslation();
  const { myTibStore } = useStores();
  const [show, setShow] = useState({
    addLine: false,
    searchLine: "",
  });
  const [showConfirm, setShowConfirm] = useState({ show: false, id: -1 });

  const handleRemove = ({ ...data }) => {
    myTibStore.removeLine(data.lineId);
  };

  const handleAdd = ({ ...data }) => {
    setShowConfirm({ show: true, id: data.id });
  };

  const onAccept = () => {
    setShowConfirm({ ...showConfirm, show: false });
    showSnackbar();
    myTibStore.addLine(showConfirm.id);
    setShow({ ...show, addLine: false });
  }

  const onReject = () => {
    setShowConfirm({ show: false, id: -1 });
  }

  const handleAlert = ({ ...data }) => {
    const { row, checked } = data;
    myTibStore.updateLine(row.lineId, checked.toString());
  };

  const handleShow = (data: any) => {
    myTibStore.getAllLines(data.searchLine);
    setShow({ ...data });
  };

  return (
    <div className="favs-table">
      <>
        <Modal
          visible={show.addLine}
          content={
            <div>
              {showConfirm.show ? <ConfirmModal onReject={onReject} onAccept={onAccept} /> : ''}
              <div className="title">{t("fav_lines")}</div>
              <div className="subtitle">
                <Input
                  disabled={false}
                  placeholder={t("search_fav_line")}
                  label=""
                  value={show.searchLine}
                  onChange={(e) =>
                    handleShow({ ...show, searchLine: e.target.value })
                  }
                />
              </div>
              <AllLines allLines={props.allLines} handleAdd={handleAdd} />
            </div>
          }
          onHide={() => handleShow({ ...show, addLine: false, searchLine: "" })}
        />
        <div className="flex-container justify-end">
          <div className="title">{t("fav_lines")}</div>
          <SecondaryButton
            icon="plus"
            text={t("add")}
            onClick={() => handleShow({ ...show, addLine: true })}
          />
        </div>
        {props.favLines.length ? (
          <TableData
            rows={5}
            items={props.favLines}
            headers={[
              { id: "code", label: t("code") },
              { id: "name", label: t("name") },
              { id: "notifications", label: t("headers.alerts") },
              { id: "action", label: "" },
            ]}
            icon="times"
            alertSvg={alert}
            alertSvg_alt={alert_alt}
            loading={props.loading}
            onActionClick={(data: any) => handleRemove(data)}
            onNotificationClick={(data: any) => handleAlert(data)}
          />
        ) : (
          <div data-testid="no-lines" className="no_items">
            {t("no_items")}
          </div>
        )}
      </>
    </div>
  );
};

export default FavLines;
